import React from 'react';
import { connect } from "react-redux";
import './../main.scss'
import './table.scss'
import logout from './../../../Global/logout'
import checkJwt from './../../../Global/jwtChecker'
import { AiOutlineSearch } from 'react-icons/ai'
import { BsCaretDown, BsCaretUp } from 'react-icons/bs'
import GetClientList from './../../../API/Admin/GetClientList'

export class Search extends React.Component{
    state={
        advanceSearch: false
    }

    componentDidMount = async () => {
    }

    
    searchInvoices = async () =>{
        const unHashedJwt = await checkJwt()
  
        if(!unHashedJwt){
            logout()
        }      
        
        this.props.mapState("ADMIN_MAP_LOADING_CLIENT", true)
  
        const clientList = await GetClientList(
            this.props.search.activePage, 
            this.props.search.pageSize, 
            this.props.search.clientName,
            this.props.search.clientAddress,
            this.props.search.clientEmail,
            this.props.search.clientPhoneNumber,
            this.props.search.clientVAT,
            this.props.search.clientDomain,
            this.props.search.clientOIB
          )
        if(!clientList.error){           
            await this.props.mapState("ADMIN_MAP_CLIENT_LIST", clientList.data)  
            if(clientList.data.totalNumberOfRecords < 1){
                this.props.mapState("ADMIN_MAP_CLIENT_LIST_MESSAGE", "Pretraga nema rezultata")
            }           
        }
        else{
          logout()
        }

        this.props.mapState("ADMIN_MAP_LOADING_CLIENT", false)
    }

    handleChange = async (e) => { 
        await this.props.mapState("ADMIN_CHANGE_SEARCH_CLIENT_PARAMETERS", e.target)
           
    }

    advanceSearchToggler(e){
        this.setState({
            advanceSearch: !this.state.advanceSearch
        })
    }


    render(){
        const {advanceSearch} = this.state  

        return(
            <div style={{border: "2px solid gray", padding: "20px", margin: "40px 0px 40px 0px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-lg-6 col-md-12">
                            <div className="form-group row">
                                <label htmlFor="clientName" className="col-sm-6 col-form-label">Naziv</label>
                                <div className="col-sm-6">
                                    <input        
                                        id="clientName"                    
                                        type="text"
                                        value={this.props.search.clientName}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div> 
                            </div>                            
                        </div>
                        <div className="col-sm-12 col-lg-6 col-md-12">      
                                     
                        <div className="form-group row">
                            <label htmlFor="clientAddress" className="col-sm-6 col-form-label">Adresa</label>
                            <div className="col-sm-6">
                                <input        
                                    id="clientAddress"                    
                                    type="text"
                                    value={this.props.search.clientAddress}
                                    onChange={e => this.handleChange(e)}
                                />
                            </div> 
                        </div>                                                              
                    </div>                
                </div>
                    {advanceSearch ?
                        <>
                        <div className="row">
                            <div className="col-sm-12 col-lg-6 col-md-12">
                                <div className="form-group row">
                                    <label htmlFor="clientPhoneNumber" className="col-sm-6 col-form-label">Telefon</label>
                                    <div className="col-sm-6">
                                        <input        
                                            id="clientPhoneNumber"                    
                                            type="text"
                                            value={this.props.search.clientPhoneNumber}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </div> 
                                </div>                            
                            </div>
                            <div className="col-sm-12 col-lg-6 col-md-12">      
                                        
                            <div className="form-group row">
                                    <label htmlFor="clientEmail" className="col-sm-6 col-form-label">Email</label>
                                    <div className="col-sm-6">
                                        <input        
                                            id="clientEmail"                    
                                            type="text"
                                            value={this.props.search.clientEmail}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </div> 
                                </div>                                                              
                            </div>                
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-lg-6 col-md-12">
                                <div className="form-group row">
                                    <label htmlFor="clientVAT" className="col-sm-6 col-form-label">VAT</label>
                                    <div className="col-sm-6">
                                        <input        
                                            id="clientVAT"                    
                                            type="text"
                                            value={this.props.search.clientVAT}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </div> 
                                </div>                            
                            </div>
                            <div className="col-sm-12 col-lg-6 col-md-12">  
                                <div className="form-group row">
                                    <label htmlFor="clientDomain" className="col-sm-6 col-form-label">Domena</label>
                                    <div className="col-sm-6">
                                        <input        
                                            id="clientDomain"                    
                                            type="text"
                                            value={this.props.search.clientDomain}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </div> 
                                </div>                                                              
                            </div>       
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-lg-6 col-md-12">
                                <div className="form-group row">
                                    <label htmlFor="clientOIB" className="col-sm-6 col-form-label">OIB</label>
                                    <div className="col-sm-6">
                                        <input        
                                            id="clientOIB"                    
                                            type="text"
                                            value={this.props.search.clientOIB}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </div> 
                                </div>                            
                            </div>
                        </div>
                        </>
                        
                    :
                        null
                    }
                    <div className="form-group row">
                        <div className="col-sm-12 col-form" style={{textAlign: "center"}}>
                            <div  
                                className="napredna-pretraga-text"
                                href={void(0)}
                                style={{fontSize: "1.5rem"}} 
                                onClick={(e) => this.advanceSearchToggler(e)}                                
                            >
                                Napredna pretraga {this.state.advanceSearch ? <BsCaretUp /> : <BsCaretDown />}
                            </div> 
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-sm-12 col-form">
                            <div 
                                className="btn btn-light" 
                                style={{float:"right", fontSize: "1.5rem"}} 
                                onClick={this.searchInvoices}
                            >
                                <AiOutlineSearch/> Traži
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return { 
        activePage: state.clientRacuni.activePage,
        pageSize: state.clientRacuni.pageSize,        
        search: state.adminClient.search
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Search);

